import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { useLanguage } from '../../context/LanguageContext';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [pathname]);
  return null;
}
function DocumentLanguage() {
  const {
    language
  } = useLanguage();
  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);
  return null;
}
export function Layout() {
  return <div className="flex min-h-screen flex-col bg-cream" data-id="element-148" data-mp="3a4arlsrz35qh">
      <ScrollToTop data-id="element-149" data-mp="3f2vs7tb4zrfg" />
      <DocumentLanguage data-id="element-150" data-mp="3ezgeoux42qg5" />
      <a href="#main" className="skip-link" data-id="element-151" data-mp="3j363nlhp7a1p">
        Skip to content
      </a>
      <Navbar data-id="element-152" data-mp="3j11vusgohqw5" />
      <main id="main" className="flex-1 pt-20" data-id="element-153" data-mp="1knjk4t3dh4gv">
        <Outlet data-id="element-154" data-mp="1kouw3g6z1ij2" />
      </main>
      <Footer data-id="element-155" data-mp="1kpmko725ifzu" />
    </div>;
}